import { graphql } from '../../../graphql/generated';

export const ECARD_CONFIGS_QUERY = graphql(`
  query EcardConfigs($doctorId: ID!) {
    ecardConfigs(doctorId: $doctorId) {
      id
      cardReaderAddress
      cardReaderName
      taetigkeitsBereichName
      taetigkeitsBereichId
      ordinationName
      ordinationId
      cardPin
      vpnr
    }

    doctor(id: $doctorId) {
      id
      name
    }
  }
`);

export const DELETE_ECARD_CONFIG_MUTATION = graphql(`
  mutation DeleteEcardConfig($id: ID!) {
    deleteEcardConfig(id: $id)
  }
`);
